import { WRAPPED_NATIVE_BY_CHAIN } from './wrappedNative';

const DEFILLAMA_CHAIN: Record<string, string> = {
  ethereum: 'ethereum',
  bsc: 'bsc',
  base: 'base',
  avax: 'avax',
  polygon: 'polygon',
  arb: 'arbitrum',
  op: 'optimism',
};

type DefiLlamaPriceResp = {
  coins?: Record<string, { price?: number }>;
};

/** Fetches spot USD price from DefiLlama (public API). Returns null if unknown. */
export async function fetchTokenUsdPrice(chain: string, tokenRef: string): Promise<number | null> {
  const llamaChain = DEFILLAMA_CHAIN[chain];
  if (!llamaChain) {
    return null;
  }
  let hex: string;
  if (tokenRef === 'native') {
    const w = WRAPPED_NATIVE_BY_CHAIN[chain];
    if (!w) {
      return null;
    }
    hex = w;
  } else {
    hex = tokenRef.trim().replace(/^0x/i, '');
    if (!/^[0-9a-fA-F]{40}$/.test(hex)) {
      return null;
    }
  }
  const coinKey = `${llamaChain}:0x${hex.toLowerCase()}`;
  const url = `https://coins.llama.fi/prices/current/${encodeURIComponent(coinKey)}`;
  const res = await fetch(url);
  if (!res.ok) {
    return null;
  }
  const data = (await res.json()) as DefiLlamaPriceResp;
  const entry = data.coins?.[coinKey];
  const price = entry?.price;
  if (typeof price !== 'number' || !Number.isFinite(price) || price <= 0) {
    return null;
  }
  return price;
}

export function formatUsdPrice(price: number): string {
  if (price >= 1_000_000) {
    return price.toLocaleString(undefined, { maximumFractionDigits: 0 });
  }
  if (price >= 1) {
    return price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  if (price >= 0.0001) {
    return price.toLocaleString(undefined, { maximumFractionDigits: 6 });
  }
  return price.toPrecision(4);
}
